module.exports = __webpack_public_path__ + "static/img/DSC_0016.a4ef2ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0016.jpg
// module id = GyL+
// module chunks = 0